import ConsultationApplication from '../components/forms/ConsultationApplication'

const Application = () => <ConsultationApplication />

export default Application
